import { useEffect, useState,useContext } from "react";
import { fetchUserByID } from "../../services/real-star-api/users/user";
import { ROLES, ROLE_ID } from "../../constants/roles";
import {  setAgentDetails } from "../../state/action";
import FormContext from "../../context/form-context";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { encryptingUserID } from "../../services/real-star-api/users/encrypt";



const useSelectAgentModal = (openModal , setOpenModal) => {
    const { appState, dispatch} = useContext(FormContext);
    const { agentNames  } = appState
    const [loading, setLoading] = useState(false);
    const { auth } = useAuth();
    const [allAgentNames, setAllAgentNames] = useState([])
    const [selectedAgent, setSelectedAgent] = useState('')
    const isHQ = auth?.role === ROLES.HQ;
    const navigate = useNavigate();

    useEffect(() => {
        if (agentNames.length > 0) {
            const getAllAgents = async () => {

                //filtered to agents only and the employee group id is not null
                const allAgentsName =
                    agentNames
                        .map(agent => agent.agentName)
                        .sort();

                setAllAgentNames(allAgentsName)
            }

            if (isHQ) {
                getAllAgents();
                // console.log('fetch all agents')
            }
        }
    }, [agentNames])

    const modalAction = {
        onAgentSelected: (val) => {
            setSelectedAgent(val)
        },
        onClose: () => {
            setSelectedAgent('')
            setOpenModal(false)
        },
        onSubmit: async () => {
            if (selectedAgent) {
                setLoading(true)
                const agentID = agentNames.find(agent => agent.agentName === selectedAgent).agentID
                const agentRawDetails = await fetchUserByID(agentID);
                const encryptedID = await encryptingUserID(agentID);
                
                setLoading(false)
                dispatch(setAgentDetails(agentRawDetails))
                navigate(`/create/agent/${encryptedID}`)
            }
        },

    }
    return {
        openModal,
        modalAction,
        allAgentNames,
        selectedAgent,
        loading
    }

}

export default useSelectAgentModal;
